import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e909c0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "row small-gutter justify-end items-center" }
const _hoisted_4 = { class: "col-1 field-container" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "col-2" }
const _hoisted_7 = { class: "col-2" }
const _hoisted_8 = {
  key: 1,
  class: "releases-grid"
}
const _hoisted_9 = ["data-testid", "onClick", "onKeyup"]
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "release-item-details" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { class: "text-dark-grey" }
const _hoisted_14 = { class: "text-primary" }
const _hoisted_15 = { class: "release-date" }
const _hoisted_16 = {
  key: 2,
  class: "text-center"
}

import { useReleasesStore } from '@/store/releases'
import { useArtistsStore } from '@/store/artists'
import { releaseTypes } from '@/constants'
import { ref, onMounted, computed } from 'vue'
import { useGettext } from 'vue3-gettext'
import dayjs from 'dayjs'
import LoaderErrorBlock from '@/components/CommonUI/LoaderErrorBlock.vue'
import ProgressBar from '@/components/AddWork/ProgressBar.vue'
import { formatReleaseArtistsToString } from '@/helpers/artists'
import { getErrorMessage } from '@/helpers/errors'
import { useRouter } from 'vue-router'
import DropdownUI from '@/components/CommonUI/DropdownUI.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'PickReleaseTab',
  setup(__props) {

const { $gettext } = useGettext()

const router = useRouter()
const releasesStore = useReleasesStore()
const artistsStore = useArtistsStore()

const isLoading = ref(false)
const errorMessage = ref('')
const allDropdownOption: DropdownOption = { id: 0, name: 'ALL' }

const artistsDropdownOptions = computed<DropdownOption[]>(() => {
  if (!artistsStore.artistsWithReleases) {
    return [allDropdownOption]
  }

  return [allDropdownOption, ...artistsStore.artistsWithReleases.map<DropdownOption>(({ id, name }) => ({ id, name }))]
})

const releaseTypeDropdownOption = computed<DropdownOption[]>(
  () => [allDropdownOption, ...Object.entries(releaseTypes).map<DropdownOption>(([id, name]) => ({ id: Number(id), name }))],
)

onMounted(async () => {
  if (releasesStore.releases && artistsStore.artists) {
    isLoading.value = false

    return
  }

  try {
    isLoading.value = true

    await Promise.all([
      releasesStore.getReleases(),
      artistsStore.getArtists(),
    ])

    isLoading.value = false
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
})

async function getReleases() {
  try {
    isLoading.value = true

    await Promise.all([
      releasesStore.getReleases(),
    ])

    isLoading.value = false
  } catch (error) {
    errorMessage.value = getErrorMessage(error)
  }
}

function changePage(page: number): void {
  releasesStore.$patch({
    filters: {
      page,
    },
  })
  getReleases()
}

function changeArtist(id: number) {
  releasesStore.$patch({
    filters: {
      'artists.id': id ? [id] : [],
    },
  })
  getReleases()
}

function changeReleaseType(id: number) {
  releasesStore.$patch({
    filters: {
      typeId: id || null,
    },
  })
  getReleases()
}

function selectRelease(release: Release) {
  releasesStore.$patch({
    selectedRelease: release,
  })

  router.push(`/works/create/${release.id}`)
}

return (_ctx: any,_cache: any) => {
  const _component_vue_awesome_paginate = _resolveComponent("vue-awesome-paginate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", {
      class: "light-text",
      innerHTML: _unref($gettext)('Register a new <strong>Musical Work</strong>')
    }, null, 8, _hoisted_1),
    _createVNode(ProgressBar),
    _createElementVNode("h3", {
      class: "light-text no-space",
      innerHTML: _unref($gettext)('Pick a <strong>release</strong>')
    }, null, 8, _hoisted_2),
    _withDirectives((_openBlock(), _createElementBlock("small", null, [
      _createTextVNode("Choose a release to register tracks for publishing.")
    ])), [
      [_directive_translate]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_5, [
          _createTextVNode(" Filter by: ")
        ])), [
          [_directive_translate]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(DropdownUI, {
          name: "artist-select",
          "data-testid": "artist-select",
          "toggle-class": "button secondary",
          "toggle-text": _unref($gettext)('Artist'),
          disabled: isLoading.value,
          options: artistsDropdownOptions.value,
          "onUpdate:modelValue": changeArtist
        }, null, 8, ["toggle-text", "disabled", "options"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(DropdownUI, {
          name: "release-type-select",
          "data-testid": "release-type-select",
          "toggle-class": "button secondary",
          "toggle-text": _unref($gettext)('Release Type'),
          disabled: isLoading.value,
          options: releaseTypeDropdownOption.value,
          "onUpdate:modelValue": changeReleaseType
        }, null, 8, ["toggle-text", "disabled", "options"])
      ])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoaderErrorBlock, {
          key: 0,
          "error-message": errorMessage.value
        }, null, 8, ["error-message"]))
      : (_unref(releasesStore).releases?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(releasesStore).releases, (release) => {
              return (_openBlock(), _createElementBlock("div", {
                key: release.id,
                class: "release-item panel elevate bg-white",
                "data-testid": `release-item${release.id}`,
                onClick: ($event: any) => (selectRelease(release)),
                onKeyup: ($event: any) => (selectRelease(release))
              }, [
                _createElementVNode("img", {
                  src: release.artwork?.small || require('@/assets/no-image.png'),
                  alt: release.title
                }, null, 8, _hoisted_10),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", {
                    class: "release-title truncate-line",
                    title: release.title
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(release.title), 1)
                  ], 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("small", null, [
                      _createTextVNode(_toDisplayString(_unref(releaseTypes)[release.typeId]) + " by: ", 1),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(formatReleaseArtistsToString)(release.artists)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(dayjs)(release.releaseDate).format('YYYY')), 1)
                ])
              ], 40, _hoisted_9))
            }), 128))
          ]))
        : _withDirectives((_openBlock(), _createElementBlock("h4", _hoisted_16, [
            _createTextVNode(" No releases yet ")
          ])), [
            [_directive_translate]
          ]),
    (_unref(releasesStore).releases && _unref(releasesStore).releasesCount > _unref(releasesStore).filters.perPage)
      ? (_openBlock(), _createBlock(_component_vue_awesome_paginate, {
          key: 3,
          modelValue: _unref(releasesStore).filters.page,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(releasesStore).filters.page) = $event)),
          class: "pagination",
          "total-items": _unref(releasesStore).releasesCount,
          "items-per-page": _unref(releasesStore).filters.perPage,
          "max-pages-shown": 4,
          "on-click": changePage,
          "disable-pagination": isLoading.value,
          "hide-prev-next": "",
          "data-testid": "pick-release-pagination"
        }, null, 8, ["modelValue", "total-items", "items-per-page", "disable-pagination"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})